import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import SchemaOrg from '@/components/feature/SchemaOrg';
import Breadcrumb from '@/components/base/Breadcrumb';
import ComicCard from '@/components/base/ComicCard';
import { comics, categories } from '@/mocks/comics';

export default function CategoryPage() {
  const { slug = 'all' } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState(slug);

  useEffect(() => {
    setActiveCategory(slug);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [slug]);

  const filtered = activeCategory === 'all'
    ? comics
    : comics.filter((c) => c.category === activeCategory);

  const currentCategoryName =
    categories.find((c) => c.slug === activeCategory)?.name || '全部';

  return (
    <>
      <SEOHead
        title={`${currentCategoryName}韩漫 - 韩漫在线观看_免费下拉式漫画_韩漫之家`}
        description={`韩漫之家提供丰富的${currentCategoryName}韩漫免费在线观看，下拉式阅读，智能加载，流畅舒适的韩漫阅读体验。海量${currentCategoryName}漫画每日更新。`}
        keywords={`${currentCategoryName}韩漫,韩漫在线观看,免费漫画,下拉式,韩漫之家`}
        canonical={`https://hanmanzhijia.com/category/${slug}`}
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: `${currentCategoryName}韩漫 - 韩漫之家`,
          description: `韩漫之家${currentCategoryName}漫画分类页面，免费下拉式在线观看。`,
          url: `https://hanmanzhijia.com/category/${slug}`,
        }}
      />

      <Navbar />
      <main className="pt-20 pb-16 min-h-screen">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="mb-6">
            <Breadcrumb
              items={[
                { label: '首页', path: '/' },
                { label: currentCategoryName },
              ]}
            />
          </div>

          <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            {currentCategoryName}韩漫
          </h1>
          <p className="text-sm text-foreground-600 mb-8">
            共 {filtered.length} 部漫画，下拉式阅读，流畅舒适
          </p>

          <div className="flex flex-wrap items-center gap-2 mb-8">
            {categories.map((cat) => (
              <button
                key={cat.slug}
                onClick={() => {
                  navigate(`/category/${cat.slug}`);
                }}
                className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                  activeCategory === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-700 hover:bg-background-200'
                }`}
              >
                <i className={`${cat.icon} text-sm`}></i>
                {cat.name}
              </button>
            ))}
          </div>

          {filtered.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
              {filtered.map((comic) => (
                <ComicCard key={comic.id} {...comic} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <i className="ri-inbox-line text-5xl text-foreground-400 mb-4 block"></i>
              <p className="text-foreground-600">该分类暂无漫画，请浏览其他分类</p>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}